import { Link } from "react-router-dom";
import { ArrowUpRight, Gift } from "lucide-react";
import { GUIDES } from "../data/guides";
import { Reveal } from "../components/Reveal";

export default function Guides() {
  return (
    <div data-testid="guides-page">
      <section className="pt-32 lg:pt-40 pb-16 px-6 lg:px-12 max-w-7xl mx-auto">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full bg-gold/90 px-5 py-2 text-xs uppercase tracking-[0.25em] text-olive-dark font-medium">
            <Gift className="w-4 h-4" strokeWidth={1.5} /> Offerts
          </span>
          <h1 className="mt-6 font-serif text-5xl sm:text-6xl font-light tracking-tight text-ink leading-tight max-w-3xl">
            Mes guides offerts
          </h1>
          <p className="mt-8 text-base sm:text-lg text-sage leading-relaxed max-w-2xl">
            Des petits guides gratuits, simples et doux, pour prendre soin de vous chez vous. Choisissez le vôtre : je vous l'envoie par e-mail en quelques secondes.
          </p>
        </Reveal>
      </section>

      <section className="pb-24 px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8" data-testid="guides-list">
          {GUIDES.map((g, i) => (
            <Reveal key={g.slug} delay={(i % 2) * 0.1}>
              <Link
                to={g.to}
                data-testid={`guide-card-${g.slug}`}
                className="group block h-full overflow-hidden rounded-3xl border border-olive-border bg-beige-50 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_25px_50px_-25px_rgba(49,63,21,0.35)]"
              >
                <div className="overflow-hidden">
                  <img
                    src={g.cover}
                    alt={g.coverAlt}
                    loading="lazy"
                    className="w-full h-60 object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-8">
                  <span className="text-xs uppercase tracking-[0.2em] text-olive">Guide offert · gratuit</span>
                  <h2 className="mt-3 font-serif text-2xl sm:text-3xl text-ink group-hover:text-olive transition-colors duration-300 leading-snug">{g.title}</h2>
                  <p className="mt-4 text-sage leading-relaxed">{g.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-olive">
                    Recevoir ce guide <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
